import { DisplayScreen } from "@unlimited-robotics/ur-ui-kit";
import React, { useEffect, useMemo, useState } from "react";
import Modal from "react-modal";

const customStyles = {
  overlay: {
    // backgroundColor: `${COLORS.primary.oxford}80`,
    zIndex: "999",
  },

  content: {
    zIndex: "888",
    width: "100%",
    overflow: "unset",
    height: "100%",
    top: "50%",
    left: "50%",
    right: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0 ",
  },
};

const WholePageCover = ({ errors }) => {
  const [type, setType] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (Object.values(errors).length) {
      setType("error");
      setIsOpen(true);
    } else {
      setType(null);
      setIsOpen(false);
    }
  }, [errors]);

  const content = useMemo(() => {
    switch (type) {
      case "error":
        return (
          <DisplayScreen
            title="Invalid arguments"
            subtitle={JSON.stringify(errors, null, 2)}
            theme="WHITE"
            custom_style={{
              title: { color: "red" },
            }}
          />
        );

      default:
        <div>No content</div>;
        break;
    }
  }, [type, errors]);

  return (
    <Modal onRequestClose={() => {}} isOpen={!!isOpen} style={customStyles} ariaHideApp={false}>
      {content}
    </Modal>
  );
};

export default WholePageCover;
